<template>
  <div id="StockInformationPopOver" class="no-gutters no-wrap">
    <LoadingSpinner v-show="isLoadingFacingWarehouse" />
    <i v-if="fullPartDetail.IsSpecialOrder">Special Order</i>
    <i v-else-if="fullPartDetail.IsDropShip">Drop Shipped</i>
    <span v-else-if="isRpiServiced()">
      {{ rpiWarehouseCode }} ({{ rpiWarehouseQuantity }})
    </span>
    <span v-else-if="!isNullOrWhiteSpace(facingWarehouseCode)">
      {{ facingWarehouseCode }} ({{ facingWarehouseQuantity }})
    </span>
    <i v-else-if="!IsNullOrUndefined(dealerStock) && externalStock.length < 1 && dealerStock.length > 0">
      Dealer Stock
    </i>
    <br>
    <span
      v-show="!isLoadingFacingWarehouse"
      :id="'stockInfoPopover-' + orderItemId"
      class="noHrefLink"
      :title="popoverTitle"
    >
      {{ totalStockQty }} total
    </span>
    <b-popover
      v-show="!isLoadingFacingWarehouse"
      :target="'stockInfoPopover-' + orderItemId"
      placement="auto"
      triggers="click hover"
    >
      <div v-if="!fullPartDetail.IsDropShip && fullPartDetail.WarehouseStockQuantities != null && fullPartDetail.WarehouseStockQuantities.length > 0">
        <th colspan="2">
          Warehouse Stock
        </th>
        <tr v-for="(warehouse, index) in fullPartDetail.WarehouseStockQuantities" :key="index">
          <td>{{ warehouse.WarehouseDescription }}</td>  <td>{{ warehouse.Quantity }}</td>
        </tr>
      </div>
      <div v-if="fullPartDetail.IsDropShip && !IsNullOrUndefined(externalStock) && externalStock.length > 0">
        <th colspan="2">
          External Stock
        </th>
        <tr v-for="(externalStock, index) in externalStock" :key="index">
          <td>{{ externalStock.Description }}</td> 
          <td>{{ externalStock.Quantity }}</td>
        </tr>
      </div>
      <div v-if="!IsNullOrUndefined(dealerStock) && dealerStock.length > 0">
        <th colspan="2">
          Dealer Stock
        </th>
        <tr v-for="(dealerStock, index) in dealerStock" :key="index">
          <td>{{ dealerStock.Description }}</td> 
          <td>{{ dealerStock.Quantity }}</td>
        </tr>
      </div>
    </b-popover>
    <br>
    <span>
      {{ getSalesOrganizationText(fullPartDetail.SalesOrganization) }}
    </span>
  </div>
</template>

<script>
  import { stringHelper } from "@/components/mixins/stringHelper";
  import { globalHelper } from "@/components/mixins/globalHelper";
  import { PartsService } from "@/services/PartsService"
  import LoadingSpinner   from "@/components/Elements/LoadingSpinner"
  import { mapGetters }   from "vuex"
  export default {
    components: {
      LoadingSpinner
    },
    mixins: [stringHelper, globalHelper],

    props: {
      partId: {
        type: Number,
        default: null
      },
      //for custom dealer parts. Used on Part Store Order Details Page
      accountCustomerPartId: {
        type: Number,
        default: null
      },
      // passing order item Id, so we can differentiate rows with the same partId
      orderItemId: {
        type: Number,
        default: null
      },
    },
    data: () => ({
      isLoadingFacingWarehouse: true,
      fullPartDetail: Object,
      totalStockQty: Number,
      popoverTitle: "Stock Information",
      facingWarehouseQuantity: 0,
      facingWarehouseCode: null,
      rpiWarehouseQuantity: Number,
      rpiWarehouseCode: String,

    }),
    computed: {
      ...mapGetters(["facingWarehouse", "user", "audienceAndExclusions", "activeAccountId"]),
      dealerStock(){
        if(!this.IsNullOrUndefined(this.fullPartDetail.ExternalStockQuantities)){
          return this.fullPartDetail.ExternalStockQuantities.filter(x => x.ExternalStockSourceType === "Dealer");
        }
        return null;
      },
      externalStock(){
        if(!this.IsNullOrUndefined(this.fullPartDetail.ExternalStockQuantities)){
          return this.fullPartDetail.ExternalStockQuantities.filter(x => x.ExternalStockSourceType !== "Dealer")
        }
        return null;
      }
    },
    mounted() {
      let audienceIds = this.audienceAndExclusions ? this.audienceAndExclusions.AudienceIds : null;
      this.getStockInfo(this.activeAccountId, this.user.UserId, this.partId, audienceIds, this.accountCustomerPartId);
    },
    methods: {
      getStockInfo(accountId, userId, partId, audienceIds, accountCustomerPartId){
        PartsService.FullPartDetails(accountId, userId, partId, audienceIds, null, accountCustomerPartId)
          .then(fullPartDetail => {
            return this.fullPartDetail = fullPartDetail.data;         
          })
          .then(() => {
            this.isRpiServiced();
            this.sumQuantities();
            this.setFacingWarehouseDisplay();
          })
      },
      getSalesOrganizationText(salesOrgId){
        switch(salesOrgId){
        case 1:
          return "MA";
        case 2:
          return "ME";
        case 3:
          return "MS";
        case 4:
          return "RP";
        default:
          return "";
        }
      },
      // this sets the main warehouse we show
      setFacingWarehouseDisplay(){
        let warehouseQuantities = this.fullPartDetail.WarehouseStockQuantities;

        if(!warehouseQuantities){
          this.isLoadingFacingWarehouse = false;
          return;
        }

        if(this.facingWarehouse.length > 0){
          let stockFacingWarehouse = warehouseQuantities.find(x => {
            return x.WarehouseCode == this.facingWarehouse[0]; // first warehouse should be stock facing, the rest are alternates
          })

          if(stockFacingWarehouse){
            this.facingWarehouseCode = stockFacingWarehouse.WarehouseCode;
            this.facingWarehouseQuantity = stockFacingWarehouse.Quantity;
          }
        }
        this.isLoadingFacingWarehouse = false;
      },
      isRpiServiced(){
        if(this.fullPartDetail.SalesOrganization !== 4 ){ //RP
          return false;
        }

        if(this.fullPartDetail.WarehouseStockQuantities.length <= 0){
          return false;
        }

        // check plant code
        let rpiWarehouse = this.fullPartDetail.WarehouseStockQuantities
          .find(x => {
            return x.PlantCode === "GR02";
          });

        if(rpiWarehouse){
          this.rpiWarehouseCode = "GRR";
          this.rpiWarehouseQuantity = rpiWarehouse.Quantity;
          return true;
        }
        else{
          return false;
        }
      },
      sumQuantities(){
        let warehouseQuantities = this.fullPartDetail.WarehouseStockQuantities;
        let externalStock = this.fullPartDetail.ExternalStockQuantities;

        let total = 0;

        if(warehouseQuantities !== null && warehouseQuantities.length !== 0){
          for(let i = 0; i < warehouseQuantities.length; i++){
            total += warehouseQuantities[i].Quantity;
          }
        }
        if(externalStock !== null && externalStock.length !== 0){
          for(let i = 0; i < externalStock.length; i++){
            total += externalStock[i].Quantity;
          }
        }

        this.totalStockQty = total;
      },
    }
  };
</script>
